import { render } from "./Failure.vue?vue&type=template&id=78703e84&ts=true"
import script from "./Failure.vue?vue&type=script&lang=ts"
export * from "./Failure.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__